import React from 'react';
import './ApplyStep.css';

export default class ApplyStep extends React.Component {

    constructor() {
        super();

        
    }

    render() {
        
        return <div>

<form onSubmit={(event) => {
                    if(this.props.disabled != null && this.props.disabled) return;
                    event.preventDefault();

                    this.props.onNext();
                }}>
                <div className='headerheDiv' style={{display:"flex", maxWidth:640,flexWrap:"wrap",width:"100%", justifyContent:"space-between"}}>
                {this.props.children}
                <div style={{display:"flex",flex:1, justifyContent:(!this.props.onPrev)?"flex-end":"space-between", marginTop:30}}>
                
                {this.props.onPrev && <button type='button' onClick={() => this.props.onPrev()} className='applyPrev' style={{fontWeight:600}}>
                <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="18" height="18" viewBox="0 0 18 18" className="ax-with-arrow">
  <path d="M6.434 12.27l3.445-3.445-3.445-3.445 1.055-1.055 4.5 4.5-4.5 4.5z"></path>
</svg>
                    Önceki
                    
                    </button>}

                <button disabled={(this.props.disabled != undefined)?this.props.disabled:false} className='applySubmit' style={{fontWeight:600}}>
                    {this.props.last?"Başvur":"Sonraki"}
                    <svg fill='white' xmlns="http://www.w3.org/2000/svg" version="1.1" width="18" height="18" viewBox="0 0 18 18" className="ax-with-arrow">
                        <path d="M6.434 12.27l3.445-3.445-3.445-3.445 1.055-1.055 4.5 4.5-4.5 4.5z"></path>
                    </svg>
                    </button>
                </div>
                
                </div>
                </form>
          
        </div>
    }

}